import React from 'react';
import { NavLink } from 'react-router-dom';

const Navigation = ({ mode = 'horizontal' }) => {
  const links = [
    { to: '/', label: 'Tools', exact: true },
    { to: '/how-it-works', label: 'How it Works' },
    { to: '/features', label: 'Features' },
    { to: '/faq', label: 'FAQ' },
    { to: '/about', label: 'About' }
  ];

  const baseStyles = "transition-all duration-300 font-bold tracking-tight text-xs uppercase";
  const activeStyles = "text-purple-400 text-glow scale-105";
  const inactiveStyles = "text-slate-400 hover:text-purple-300 hover:scale-105";

  if (mode === 'footer') {
    return (
      <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12 py-8 border-b border-white/5 mb-8">
        {links.map(link => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.exact}
            className={({ isActive }) => `${baseStyles} ${isActive ? activeStyles : inactiveStyles}`}
          >
            {link.label}
          </NavLink>
        ))}
      </div>
    );
  }

  return (
    <nav className="hidden md:flex items-center gap-8 ml-12">
      {links.map(link => (
        <NavLink
          key={link.to}
          to={link.to}
          end={link.exact}
          className={({ isActive }) => `${baseStyles} ${isActive ? activeStyles : inactiveStyles}`}
        >
          {link.label}
        </NavLink>
      ))}
    </nav>
  );
};

export default Navigation;
